import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SidebarStateModel, ToggleSidebar } from './sidebar.model';

@State<SidebarStateModel>({
  name: 'sidebar',
  defaults: {
    collapsed: false
  }
})
export class SidebarState {
  @Selector()
  static collapsed(state: SidebarStateModel) {
    return state.collapsed;
  }

  constructor() {}

  @Action(ToggleSidebar)
  toggleSidebar(
    { patchState }: StateContext<SidebarStateModel>,
    payload: SidebarStateModel
  ) {
    return patchState(payload);
  }
}
